<template>
  <div class="externalContent">
    <div class="searchBox">
      <el-input
        style="width: 55%"
        size="small"
        placeholder="输入姓名/手机号进行过滤"
        v-model="filterText"
      >
      </el-input>
    </div>
    <div class="contentWarp">
      <div class="leftWarp">
        <div class="title">待选人员</div>

        <el-tree
          :key="updateTreeKey"
          ref="tree"
          :data="data"
          :props="defaultProps"
          node-key="userId"
          :filter-node-method="filterNode"
          @check="check"
          default-expand-all
          show-checkbox
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span v-if="node.level === 1">{{ data.company }}</span>
            <span v-else>{{ `${data.userName}(${data.phone})` }}</span>
          </span>
        </el-tree>
      </div>
      <div class="rightWarp">
        <div class="titleAddMore">
          <div class="title">已选人员</div>
        </div>
        <div class="checkList">
          <div v-for="item in checkData" :key="item.userId" class="item">
            <div class="name">{{ `${item.userName}(${item.phone})` }}</div>
            <div>
              <i class="el-icon-close" @click="delCheckPerson(item)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import projectHome from "@/xgzdService/projectHome-service";
import { mapState } from "vuex";
export default {
  name: "external",

  data() {
    return {
      filterText: "",
      data: [],
      defaultProps: {
        children: "userList",
        label: "label",
        isLeaf: function (data) {
          return !!data.userId;
        },
      },
      checkData: [],
      updateTreeKey: 0,
    };
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },

  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId,
    }),
  },


  methods: {
    async queryExternalRoleTree() {
      const { prjId } = this.prjInfo;
      const res  = await projectHome.getprjPersonAll(prjId);
      if (Array.isArray(res?.data?.[0].outsiderList)) {
        this.data = res.data[0].outsiderList
      }
    },
    check(data, { checkedNodes }) {
      this.checkData = checkedNodes.filter((item) => item.userId);
    },

    delCheckPerson(item) {
      const index = this.checkData.findIndex(
        (person) => person.userId === item.userId
      );
      if (index > -1) {
        this.checkData.splice(index, 1);
        this.$refs.tree.setChecked(item.userId, false);
      }
    },
    setPerson(data){
      this.checkData = data?.map(ele=>{
        let phone='';
        this.data.forEach(item => {
          const info = item?.userList?.find(({userId})=>userId===ele.userId)?.phone
          if(info)phone=info
        });
        return{
          userId:ele.userId,
          userName:ele.userName,
          phone,
        }
      })
      for (const key of data) {
         this.$refs.tree.setChecked(key.userId, true);
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      if (data.company) return false;
      return (
        data.userName.indexOf(value) !== -1 || data.phone.indexOf(value) !== -1
      );
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.externalContent {
  width: 100%;
  height: 500px;
  padding-top: 10px;
  box-sizing: border-box;

  .contentWarp {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: calc(100% - 42px);
    padding-top: 10px;

    .leftWarp {
      width: 55%;
      height: 100%;

      .title {
        height: 32px;
        line-height: 32px;
        padding: 0 5px;
        box-sizing: border-box;
        font-size: 16px;
      }

      /deep/ .el-tree {
        height: calc(100% - 32px);
        overflow-y: auto;
        border: 1px solid #D4D9EC;
      }
    }

    .rightWarp {
      width: 40%;
      height: 100%;
      overflow-y: auto;

      .titleAddMore {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 5px;
        box-sizing: border-box;

        .title {
          font-size: 16px;
        }
      }

      .checkList {
        height: calc(100% - 32px);
        overflow-y: auto;
        border: 1px solid #D4D9EC;

        .item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid rgba(46, 91, 255, 0.1);
          height: 50px;
          padding: 0 20px;
          box-sizing: border-box;

          i {
            font-size: 16px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
